import { object as objectUtil } from "./object/"
import { array as arrayUtil } from "./array/";
import { file as fileUtil } from "./file/";
import { blob as blobUtil } from "./blob/";
import { image as imageUtil } from "./image/";


export namespace util {
    // todo: 这里tsconfig如何处理util为{}空对象
    export import object = objectUtil;
    export import array = arrayUtil;
    export import file = fileUtil;
    export import blob = blobUtil;
    export import image = imageUtil;

    // 或export const object = objectUtil;
    util.object = object;
    util.array = array;
    util.file = file;
    util.blob = blob;
    util.image = image;
}
